<p-dialog [visible]="showUploadDialog()" [modal]="true" [closable]="false">
  <ng-template #header>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4>{{ title() }}</h4>
      </div>
    </div>
  </ng-template>

  <ng-template #content>

    @if (hasInvalidFileNames()) {
      <div class="alert alert-danger d-flex flex-column" role="alert">
        <strong>
          <i class="pi pi-exclamation-triangle me-2"></i>
          Nombres de archivo inválidos
        </strong>
        <p class="mt-2 mb-2">Los siguientes archivos contienen espacios o caracteres especiales:</p>
        <ul class="mb-2">
          @for (fileName of invalidFileNames(); track fileName) {
            <li><code>{{ fileName }}</code></li>
          }
        </ul>
        <p class="mb-0">
          <small>
            <strong>Solo se permiten:</strong> letras, números, guiones (-), guiones bajos (_) y puntos (.)
          </small>
        </p>
      </div>
    }

    @if(!options().uploaded) {
      <p-fileupload
        #fileUpload
        [name]="options().name"
        [url]="options().url"
        (onUpload)="onUpload($event)"
        (onSelect)="onSelect($event)"
        [multiple]="options().multiple"
        [accept]="options().accept"
        [maxFileSize]="options().maxFileSize"
        [mode]="options().mode"
        [disabled]="hasInvalidFileNames()"
      >
        <ng-template #empty>
          <div>Arrastra y suelta los archivos aquí para subir.</div>
        </ng-template>
      </p-fileupload>
    }
    @else {
      <div class="d-flex flex-column align-items-center">
        <i class="pi pi-check-circle" style="font-size: 2rem; color: green;"></i>
        <h5 class="mt-3">Archivo(s) subido(s) con éxito.</h5>

         <ng-container *ngFor="let it of options().uploadedFilesNames; let i = index">
          <a (click)="openWindowUploadHelp(it)">{{ it }}</a>
        </ng-container>
      </div> 
    }

  </ng-template>

  <ng-template #footer>
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary" (click)="eventClose.emit()">
        Cerrar
      </button>
    </div>
  </ng-template>
</p-dialog>